import { render, staticRenderFns } from "./VideoUser.vue?vue&type=template&id=4f191c41"
import script from "./VideoUser.vue?vue&type=script&lang=js"
export * from "./VideoUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports